type GetErrorMessageParams = {
  defaultMessage?: string;
  error: unknown;
};

export const getErrorMessage = ({
  error,
  defaultMessage,
}: GetErrorMessageParams) => {
  if (!error) {
    return '';
  }

  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    if (error.message === 'request/body/email must match format "email"') {
      return 'Invalid email';
    }

    return error.message;
  }

  return defaultMessage ?? 'Something went wrong. Please try again.';
};
